// eslint-disable-next-line no-restricted-imports
import { useNavigation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import NProgress from 'nprogress';

import StyledProgressBar from './ProgressBarStyles';

// ----------------------------------------------------------------------

export default function ProgressBar() {
  const navigation = useNavigation();

  const [mounted, setMounted] = useState(false);

  // const [visible, setVisible] = useState(false);

  const isLoading = navigation.state === 'loading';
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isLoading) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [isLoading]);

  // TODO Remove this part of code when route switch is fully tested
  // useEffect(() => {
  //   if (!visible) {
  //     NProgress.start();
  //     setVisible(true);
  //   }

  //   if (visible) {
  //     NProgress.done();
  //     setVisible(false);
  //   }

  //   if (!visible && mounted) {
  //     setVisible(false);
  //     NProgress.done();
  //   }

  //   return () => {
  //     NProgress.done();
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pathname, mounted]);

  if (!mounted) {
    return null;
  }

  return <StyledProgressBar />;
}
